import List from '@mui/material/List';
import { PendingItem } from '../PendingItem';
import {
  Typography,
} from '@mui/material';
import { PendingType } from '../PendingItem/types';

const sortByDate = (a: PendingType, b: PendingType) => a.date > b.date ? 1 : -1;

const PendingList = ({pendingList}:{pendingList:any[]}) => {
  return pendingList.length > 0 ? (
    <List disablePadding sx={{ mb: 1 }}>
      {pendingList.sort(sortByDate).slice(0, 2).map((item, index) => (
        <PendingItem item={item} key={index} />
      ))}
    </List>
  ) : (
    <Typography
        fontSize={'13px'}
        variant={'body1'}
        color={'text.secondary'}
        sx={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100%',
          position: 'absolute',
          left: '0',
          right: '0'
        }}
    >
        No Pendings found
    </Typography>
  );;
};

export { PendingList };
